"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _postprocessing = require("@react-three/postprocessing");
var _paulCorePackage = require("paul-core-package");
var _Lights = _interopRequireDefault(require("./Lights"));
var _selectors = require("../../redux/selectors");
var _PwhPipes = require("./PwhPipes");
var _HtgHx = require("./HtgHx");
var _HtgSys = require("./HtgSys");
var _HtgSub = require("./HtgSub");
var _PwhSupplies = _interopRequireDefault(require("./PwhSupplies"));
var _PwhC = _interopRequireDefault(require("./PwhC"));
var _HtgCc = _interopRequireDefault(require("./HtgCc"));
var _PwcPoe = _interopRequireDefault(require("./PwcPoe"));
var _HtgHs = _interopRequireDefault(require("./HtgHs"));
var _ConnectHtgSysToHs = _interopRequireDefault(require("./Connections/ConnectHtgSysToHs"));
var _constants = require("../../utils/constants");
var _ConnectList = _interopRequireDefault(require("./Connections/ConnectList"));
var _ConnectBetweenHtgCcAndHtgHx = _interopRequireDefault(require("./Connections/ConnectBetweenHtgCcAndHtgHx"));
var _ConnectBetweenPwhSupplyAndHtgCc = require("./Connections/ConnectBetweenPwhSupplyAndHtgCc");
var _ConnectBetweenPwhCAndPwhSupply = _interopRequireDefault(require("./Connections/ConnectBetweenPwhCAndPwhSupply"));
var _ConnectHtgHsToHtgHsGeneral = _interopRequireDefault(require("./Connections/ConnectHtgHsToHtgHsGeneral"));
var _SuspenseWrap = _interopRequireDefault(require("../SuspenseWrap"));
var _HtgPipe = require("./HtgPipe");
var _ConnectHtgHsToHtgHx = require("./Connections/ConnectHtgHsToHtgHx");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { HelperModels } from "./HelperModels";

// extend({ UnrealBloomPass });

/* @todo make dynamic preload */
const SceneContainer = () => {
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const theme = (0, _reactRedux.useSelector)(_selectors.getPackageTheme);
  (0, _react.useEffect)(() => {
    if (source) {
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/000_tubes/Tube_Straight_5m.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/000_tubes/Tube_Curve_1m.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/101_paul_smart_valve.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/101_paul_sensor.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/102_paul_smart_valve_warmwater_V6.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/103_energy_valve.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/104_paul_smart_back_wash_filter.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/107_paul_doubleSensor.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/201_point_of_entry.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/202_back_wash_filter.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/203_ultrafiltration.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/204_storage_water_heater.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/205_circulation_pump.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/206_sink.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/301_radiator.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/302_mixer.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/303_heat_exchanger.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/304_htg_Hs.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/311_district_heating.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/312_boiler_gas.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/313_bhkw.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/314_solar_thermal.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/315_heat_buffer_tank.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/316_heat_pump.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/317_heat_pump_water.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/318_heat_pump_earth.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/319_heat_pump_base.glb"));
      _drei.useGLTF.preload("".concat(source).concat(_constants.webGLModalsSource, "/panels/TemperaturePanel.glb"));
    }
  }, [source]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Lights.default, null), /*#__PURE__*/_react.default.createElement(_drei.Plane, {
    receiveShadow: true,
    rotation: [-Math.PI / 2, 0, 0],
    position: [0, -0.1, 0],
    args: [100, 300]
  }, /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    attach: "material"
  })), /*#__PURE__*/_react.default.createElement(_SuspenseWrap.default, null, /*#__PURE__*/_react.default.createElement(_HtgSys.HtgSys, null), /*#__PURE__*/_react.default.createElement(_HtgSub.HtgSub, null), /*#__PURE__*/_react.default.createElement(_ConnectHtgSysToHs.default, null), /*#__PURE__*/_react.default.createElement(_HtgHs.default, {
    type: _constants.TypesByDep.HtgHsFromHtgSys
  }), /*#__PURE__*/_react.default.createElement(_ConnectHtgHsToHtgHsGeneral.default, null), /*#__PURE__*/_react.default.createElement(_HtgHs.default, {
    type: _constants.TypesByDep.HtgHsGeneral
  }), /*#__PURE__*/_react.default.createElement(_ConnectList.default, {
    connectTo: _constants.ConnectTo.left,
    modelType: _constants.TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral,
    type: _constants.TypesByDep.HtgHsFromGeneral,
    dataType: "object",
    pipes: [{
      highlightsType: _constants.pipesTypes.heatingReturn,
      display: true
    }, {
      highlightsType: _constants.pipesTypes.heatingFlow,
      display: true
    }]
  }), /*#__PURE__*/_react.default.createElement(_HtgHs.default, {
    type: _constants.TypesByDep.HtgHsFromGeneral
  }), /*#__PURE__*/_react.default.createElement(_ConnectHtgHsToHtgHx.ConnectHtgHsToHtgHx, null), /*#__PURE__*/_react.default.createElement(_HtgHx.HtgHx, null), /*#__PURE__*/_react.default.createElement(_HtgPipe.HtgPipe, null), /*#__PURE__*/_react.default.createElement(_ConnectBetweenHtgCcAndHtgHx.default, null), /*#__PURE__*/_react.default.createElement(_ConnectList.default, {
    connectTo: _constants.ConnectTo.left,
    modelType: _constants.TypesConnect.ConnectHtgCc,
    type: _constants.TypesByDep.HtgCc,
    dataType: "object",
    hideIfListEmpty: true,
    pipes: [{
      highlightsType: _constants.pipesTypes.heatingReturn,
      display: true
    }, {
      highlightsType: _constants.pipesTypes.heatingFlow,
      display: true
    }]
  }), /*#__PURE__*/_react.default.createElement(_HtgCc.default, null), /*#__PURE__*/_react.default.createElement(_ConnectBetweenPwhSupplyAndHtgCc.ConnectBetweenPwhSupplyAndHtgCc, null), /*#__PURE__*/_react.default.createElement(_PwhSupplies.default, null), /*#__PURE__*/_react.default.createElement(_ConnectBetweenPwhCAndPwhSupply.default, null), /*#__PURE__*/_react.default.createElement(_PwhC.default, null), /*#__PURE__*/_react.default.createElement(_PwhPipes.PwhPipes, null), /*#__PURE__*/_react.default.createElement(_PwcPoe.default, null), /*#__PURE__*/_react.default.createElement(_drei.Preload, {
    all: true
  })), /*#__PURE__*/_react.default.createElement(_postprocessing.EffectComposer
  // disableNormalPass
  // multisampling={0}
  // enabled={true}
  // depthBuffer={true}
  , {
    stencilBuffer: true
    // autoClear={true}
    // resolutionScale={1024}
    // renderPriority={2}
  }, /*#__PURE__*/_react.default.createElement(_postprocessing.Bloom, {
    luminanceSmoothing: 0,
    luminanceThreshold: 0.6,
    mipmapBlur: true,
    height: 800
    // intensity={0.05}
    ,
    intensity: theme === _paulCorePackage.constants.themeKey.light ? 0 : 0.9
    // height={800}
    ,
    opacity: 1
  })));
};
var _default = exports.default = SceneContainer;